<template>
  <div>
    <el-dialog
      width="90%"
      :title="TitleForDialog"
      :visible.sync="DialoVisible"
      @close="OnDialogClose"
      @open="OnDIalogOpen"
    >
      <el-row>
        <rabbey-table3
          border
          ref="new"
          v-loading="loading"
          :data="items"
          :columns="columns"
          :actions="actions"
          :row-class-name="tableRowClassName"
          :class-table="{
            'table-box': true,
            'card-base': true,
            'card-shadow--medium': false
          }"
          paginateFromApi
          @rtable-push-action="handlePushAction"
          @update-page-size="updatePageSize"
          @update-current-page="updateCurrentPage"
        />
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="OnDialogClose">Cerrar</el-button>
        <!-- <el-button type="primary" @click="DialoVisible = true">open the inner Dialog</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import InternalRequestColumns from "@/components/internal_requests/reports/InternalRequestByModuleMonthlyReport/columns/InternalRequestColumns";

export default {
  name: "InternalRequestsByModuleReportDetail",
  props: {
    DialoVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    DirectionId: {
      type: [Number, String],
      default: "",
      required: false
    },
    EmployId: {
      type: [Number, String],
      default: "",
      required: false
    },
    ReportId: {
      type: [Number, String],
      default: "",
      required: false
    },
    ReportName: {
      type: [Number, String],
      default: "",
      required: false
    },
    ModuleId: {
      type: [Number, String],
      default: "",
      required: false
    },
    ModuleName: {
      type: [Number, String],
      default: "",
      required: false
    },
    Year: {
      type: Number,
      default: null,
      required: false
    },
    MonthSelected: {
      type: Number,
      default: null,
      required: false
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      columns: InternalRequestColumns,
      actions: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      months: {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre"
      }
    };
  },
  computed: {
    TitleForDialog() {
      let title = `Solicitudes del reporte de ${
        this.ReportNameSelected
      } del modulo de ${this.ModuleNameSelected} del mes de ${
        this.months[this.MonthFilter]
      } del año ${this.YearFilter}`;
      return title;
    },
    DirectionFilter() {
      return this.DirectionId;
    },
    EmployeeFilter() {
      return this.EmployId;
    },
    YearFilter() {
      return this.Year;
    },
    MonthFilter() {
      return this.MonthSelected;
    },
    ReportIdSelected() {
      return this.ReportId;
    },
    ReportNameSelected() {
      return this.ReportName;
    },
    ModuleIdSelected() {
      return this.ModuleId;
    },
    ModuleNameSelected() {
      return this.ModuleName;
    }
  },
  mounted() {},

  methods: {
    OnDialogClose() {
      this.$emit("ClosingDialog", false);
    },
    async OnDIalogOpen() {
      await this.getItems();
    },
    async getItems() {
      /*
      if (this.request) this.cancel();

      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
      */
      const { /*EmployeeId,*/ CompanySelected /*, IsSupervisor*/ } =
        this.currentUser;
      // const person = this.selectedEmployee; //> 0 ? this.selectedEmployee : EmployeeId;

      const params = {
        PersonId: this.EmployeeFilter,
        DirectionId: this.DirectionFilter,
        Company: CompanySelected,
        Status: null,
        // CreateByMe: this.switchCreateByMe,
        // IAmASupervisor: this.switchIAmASupervisor,
        All: true,
        // isSupervisor: IsSupervisor,
        page: this.currentPage,
        limit: this.pageSize,
        skit: 0,
        // search: this.search,
        // CreateBy: this.selectedCreator, // != null ? this.selectedCreator : this.currentUser.EmployeeId
        // StatusSoftwareDeveloper: this.StatusSoftwareDeveloperSelected,
        // DirectionsTI: this.ChangesDirectionsIT,
        // yearMonth: this.yearMonth,
        Year: this.YearFilter,
        Month: this.MonthFilter,
        ReportId: this.ReportIdSelected,
        ModuloId: this.ModuleIdSelected
      };

      this.loading = true;

      // await this.$http
      //   .get("/api/InternalServiceRequest/GetSummaryInternalService", {
      //     params: params,
      //     timeout: 3 * 60 * 1000,
      //   })
      //   .then((response) => {
      //     const { data } = response;

      //     this.cardValues = data;
      //   });

      await this.$http
        .get(
          "/api/InternalServiceRequest/GetListInternalServiceRequestSupervisor/",
          {
            params: params,
            //cancelToken: axiosSource.token,
            timeout: 3 * 60 * 1000
          }
        )
        .then((resp) => {
          const { Items, CurrentPage, ItemCount } = resp.data;

          this.currentPage = CurrentPage;
          this.total = ItemCount;
          this.items = Items;

          this.$store.commit("SET_UPDATE_INTERNAL_REQUESTS", false);

          this.$nextTick(function () {
            let p = this.$refs["new"].pagination;
            this.$refs["new"].pagination = {
              ...p,
              currentPage: CurrentPage,
              total: ItemCount
            };
          });
        })
        .finally(() => (this.loading = false));
    },
    updatePageSize(val) {
      this.pageSize = val;
      this.getItems();
    },
    updateCurrentPage(val) {
      this.currentPage = val;
      this.getItems();
    },
    tableRowClassName({ row: { CreatedAt, SlaDaysToResponse } }) {
      const now = this.$moment();
      var diference = now.diff(this.$moment(CreatedAt), "days");
      if (diference > SlaDaysToResponse) {
        return "warning-row";
      }
      return "";
    }
  }
};
</script>

<style scoped></style>
